<footer class="bg-primary footer footer-excep">

    <div fxlayout="row wrap" fxlayoutalign="space-between" class="border-bottom-mute theme-container footerAlignment" *ngIf="router.url !== '/edit-order'  &&  router.url !== '/account/orders'  && 
    router.url !== '/account/addresses' && router.url !== '/account/payment/add-credit-card'">
        <div fxflex="100" fxflex.gt-sm="20" fxflex.sm="40" *ngIf="storeDetailsJson['footer']" class="quick-links">
            <h3 class="col-title">{{storeDetailsJson['footer']['quickLinks']['title']}}</h3>
            <p class="mt-7px" *ngFor="let link of storeDetailsJson['footer']['quickLinks']['links']">
                <a [href]="link['href']" target="_blank" class="link secondary-color"
                    [title]="link['label']">{{link['label']}}</a>
            </p>
        </div><!---->
        <div fxflex="100" fxflex.gt-sm="30" fxflex.sm="60" class="contact-information contact-links"
            style="flex: 1 1 30%; box-sizing: border-box; max-width: 30%;">
            <h3 class="col-title">CONTACT INFORMATION</h3>
            <p fxLayout="row" fxLayoutAlign="start center" class="mt-1 secondary-color">
                <i class="material-icons" data-icon="location_on"></i>
                <span>{{storeDetails['address']}}</span>
            </p>
            <p fxLayout="row" fxLayoutAlign="start center" class="mt-1 secondary-color">
                <i class="material-icons" data-icon="call"></i>
                <span>{{storeDetails['phone'] | phone: 'US'}}</span>
            </p>
            <p fxLayout="row" fxLayoutAlign="start center" class="mt-1 secondary-color">
                <i class="material-icons" data-icon="schedule"></i>
                <span>Mon - Fri / 8:00AM - 6:00PM</span>
            </p>
            <p fxLayout="row" fxLayoutAlign="start center" class="mt-1 secondary-color">
                <i class="material-icons" data-icon="mail_outline"></i>
                <span>{{storeDetails['reply_to_email']}}</span>                
            </p>
        </div>
        <div *ngIf="storeDetailsJson['settings']['main-theme'] == 'Default'" fxflex="100" fxlayoutgap="15px" fxlayout="row" fxlayout.xs="column" fxflex.gt-sm="50" ngclass.sm="mt-2"
            ngclass.xs="mt-2" class=""
            style="flex-direction: row; box-sizing: border-box; display: flex; flex: 1 1 100%; max-width: 50%;">
            <div fxlayout="column"
                style="margin-right: 15px; flex-direction: column; box-sizing: border-box; display: flex;"><img
                    alt="Logo" class="footer-logo"
                    src="assets/global-theme/files/images/3/content-images/AnimalWelfareLogo-trans.png"><img
                    alt="Logo" class="footer-logo"
                    src="assets/global-theme/files/images/3/content-images/Badge-2-e1537474004227.png"></div>
            <div>
                <h2>FREE DELIVERY ON ORDERS OVER $150</h2>
                <p class="mt-2 secondary-color">Subject to products received as some
                    products may not be available.</p>
                <div fxHide.lt-sm="true" fxlayoutalign="end" class="py-2"
                    style="place-content: stretch flex-end; align-items: stretch; flex-direction: row; box-sizing: border-box; display: flex;">
                    <a href="https://www.facebook.com/CowBelleHomeMilkDelivery" target="_blank"><img
                            src="assets/global-theme/files/images/3/content-images/facebook_icon.png" alt="Facebook Icon" class="social-icon"></a>
                </div>
            </div>
        </div><!---->
    </div>

    <div fxlayout="row" fxlayout.xs="column" fxlayoutalign="space-between center"
        class="copyright secondary-color theme-container"
        style="flex-direction: row; box-sizing: border-box; display: flex; place-content: center space-between; align-items: center;">
        <p ngclass.xs="mt-1" class=""> {{storeDetailsJson['second_footer']['copyRight']['copyRightText']}}
        </p>
        <ng-container *ngIf="!!featureTags && featureTags['ftag_powered_by_fds']">
            <a href="http://farmdeliverysoftware.com/" *ngIf="storeDetails.show_powered_by_link === 1" target="_blank" class="poweredBy"> Powered by Smart FDS</a>
        </ng-container>
        <ng-container *ngIf="!!featureTags && !featureTags['ftag_powered_by_fds']">
            <a href="http://farmdeliverysoftware.com/" target="_blank" class="poweredBy"> Powered by Smart FDS</a>
        </ng-container>
    </div>

</footer>